// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgeVerificationController from "./age_verification_controller"
application.register("age-verification", AgeVerificationController)

import BlocksController from "./blocks_controller"
application.register("blocks", BlocksController)

import ClubsMapController from "./clubs_map_controller"
application.register("clubs-map", ClubsMapController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageBlockController from "./image_block_controller"
application.register("image-block", ImageBlockController)

import ImageBlurController from "./image_blur_controller"
application.register("image-blur", ImageBlurController)

import TextBlockController from "./text_block_controller"
application.register("text-block", TextBlockController)

import VideoBlockController from "./video_block_controller"
application.register("video-block", VideoBlockController)
